<template>
  <div id="app">
    <sidebar></sidebar>
    <router-view></router-view>
  </div>
</template>
<script>
import SidebarComponent from "@/components/sidebar/sidebar.component";
import NavbarComponent from "@/components/navbar/navbar.component";
import { mapMutations, mapState } from "vuex";
import APIService from "@/services/api.service";

export default {
  data: function () {
    return {
      apiService: new APIService(),
      is_session_expired: true,
    };
  },
  components: {
    navbar: NavbarComponent,
    sidebar: SidebarComponent,
  },
  async created() {
    await this.initialize();
    if (this.$route) {
      this.SET_API_HOST(this.$route.name);
    }
    if (window.$cookies.get("access_token")) {
      this.apiService
        .get_config({
          terra: this.$route.name == "terra",
          id: this.$route.params.uid,
        })
        .then((res) => {
          let vectors = {};
          res.data.forEach((c) => (vectors[c.class_id] = { ...c, count: 0 }));
          this.$store.dispatch("init_vectors", vectors);

          this.isAuthenticated();
        });
      if (this.$route.params.uid) {
        this.apiService
          .get_view_data({ id: this.$route.params.uid })
          .then((res) => {
            this.SET_ORTHOS(res.data);
          })
          .catch((err) => {
            this.$toast.open("Error :: while fetching view details.");
          });
      }
    }

    // this.$store.dispatch("set_orthos", orthos);
  },
  computed: {
    ...mapState(["token", "claims"]),
  },
  watch: {
    // Everytime the route changes, check for auth status
    $route: "isAuthenticated",
  },
  methods: {
    ...mapMutations([
      "SET_AUTHENTICATED",
      "SET_TOKEN",
      "SET_ORTHOS",
      "SET_API_HOST",
      "SET_CLAIMS",
    ]),
    isAuthenticated() {
      if (!window.$cookies.get("access_token")) {
        this.is_session_expired = false;
      }
    },
    async initialize() {
      if (!window.$cookies.get("access_token")) {
        this.is_session_expired = false;
      } else {
        try {
          let res = await this.apiService.get_claims();
          if (res && res.data) this.SET_CLAIMS(res.data);
          else {
            this.is_session_expired = false;
          }
        } catch (err) {
          this.is_session_expired = false;
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "~bulma-slider/dist/css/bulma-slider.min.css";

@font-face {
  font-family: "Barlow-Black";
  src: url(./assets/fonts/Barlow-Black.ttf);
}
@font-face {
  font-family: "Barlow-BlackItalic";
  src: url(./assets/fonts/Barlow-BlackItalic.ttf);
}
@font-face {
  font-family: "Barlow-Bold";
  src: url(./assets/fonts/Barlow-Bold.ttf);
}
@font-face {
  font-family: "Barlow-BoldItalic";
  src: url(./assets/fonts/Barlow-BoldItalic.ttf);
}
@font-face {
  font-family: "Barlow-ExtraBold";
  src: url(./assets/fonts/Barlow-ExtraBold.ttf);
}
@font-face {
  font-family: "Barlow-ExtraBoldItalic";
  src: url(./assets/fonts/Barlow-ExtraBoldItalic.ttf);
}
@font-face {
  font-family: "Barlow-ExtraLight";
  src: url(./assets/fonts/Barlow-ExtraLight.ttf);
}
@font-face {
  font-family: "Barlow-ExtraLightItalic";
  src: url(./assets/fonts/Barlow-ExtraLightItalic.ttf);
}
@font-face {
  font-family: "Barlow-Italic";
  src: url(./assets/fonts/Barlow-Italic.ttf);
}
@font-face {
  font-family: "Barlow-Light";
  src: url(./assets/fonts/Barlow-Light.ttf);
}
@font-face {
  font-family: "Barlow-LightItalic";
  src: url(./assets/fonts/Barlow-LightItalic.ttf);
}
@font-face {
  font-family: "Barlow-Medium";
  src: url(./assets/fonts/Barlow-Medium.ttf);
}
@font-face {
  font-family: "Barlow-MediumItalic";
  src: url(./assets/fonts/Barlow-MediumItalic.ttf);
}
@font-face {
  font-family: "Barlow";
  src: url(./assets/fonts/Barlow-Regular.ttf);
}
@font-face {
  font-family: "Barlow-Regular";
  src: url(./assets/fonts/Barlow-Regular.ttf);
}
@font-face {
  font-family: "Barlow-SemiBold";
  src: url(./assets/fonts/Barlow-SemiBold.ttf);
}
@font-face {
  font-family: "Barlow-SemiBoldItalic";
  src: url(./assets/fonts/Barlow-SemiBoldItalic.ttf);
}
@font-face {
  font-family: "Barlow-Thin";
  src: url(./assets/fonts/Barlow-Thin.ttf);
}
@font-face {
  font-family: "Barlow-ThinItalic";
  src: url(./assets/fonts/Barlow-ThinItalic.ttf);
}
.is-semiBold-16-600-19 {
  font-family: Barlow-SemiBold, sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 19px !important;
}
.is-medium-16-500-19 {
  font-family: Barlow-Medium, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  color: #171e48;
}
.is-semibold-12-500-14 {
  font-family: Barlow-Medium, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}
.is-semibold-16-600-19 {
  font-family: Barlow-SemiBold, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  color: #171e48;
}
.is-regular-16-000-42 {
  font-family: Barlow-Regular, sans-serif !important;
  font-size: 16px;
  font-weight: normal;
  line-height: 42px !important;
}
.is-medium-14-500-42 {
  font-family: Barlow-Medium, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 42px !important;
}
.is-semiBold-14-600-42 {
  font-family: Barlow-SemiBold, sans-serif !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 42px !important;
}
.is-semiBold-15-500-42 {
  font-family: Barlow-SemiBold, sans-serif !important;
  font-size: 14.5px;
  font-weight: 500;
  line-height: 42px !important;
}
.is-bold-16-000-106 {
  font-family: Barlow-Bold, sans-serif !important;
  font-size: 16px;
  font-weight: normal;
  line-height: 80px;
}
.is-semibold-16-000-106 {
  font-family: Barlow-SemiBold, sans-serif !important;
  font-size: 16px;
  font-weight: normal;
}

html,
body {
  overflow: hidden;
  font-family: "Barlow", sans-serif;
}

#app {
  font-family: Barlow-Regular, sans-serif;
}

.heading-secondary {
  font-weight: 500;
  font-size: 13px;
  text-transform: uppercase;
}
.is-pointer {
  cursor: pointer;
}

.tooltip {
  font-family: Barlow-Medium, sans-serif;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 0.06px;
  font-size: 13px;
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: #171e48;
    color: white;
    border-radius: 4px;
    padding: 4px 7px 8px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>



